
import { Component, Vue } from "vue-property-decorator";
import request from "@/lib/request/request";
import Auth from "@/lib/common/auth";

@Component({})
export default class VirExport extends Vue {
  st = "";
  ed = "";

  sub() {
    console.log(this.st, this.ed);
    request
      .post("/aiExam/nrxq/userExport", {
        timeStart: this.st,
        timeStop: this.ed,
        userId: Auth.userId
      })
      .then((res: any) => {
        if (res?.data?.code === 0) {
          const dataUrl = res.data.data.ossUrl;
          const a = document.createElement("a");
          a.href = dataUrl;
          a.setAttribute("download", "客户线索：" + this.st + "至" + this.ed);
          a.click();
        } else {
          this.$message.error("导出失败");
        }
      });
  }
}
